<template>
  <div class="container">
    <div class="container mb50">
      <p v-if="isRequired('bunshou')">内容を入力して保存してください。（<span class="hissu">*</span>印は必須項目です。）</p>
      <p class="blue">{{ message }}</p>
      <ValidationObserver ref="observer" tag="form">
        <table class="userEdit mt40 mb50">
          <tbody>
            <tr>
              <td>ユーザ権限<span class="hissu" v-if="isRequired('userDiv')">*</span></td>
              <td>
                <div class="radio" v-if="this.$session.get('userDiv') === 0">
                  <input id="radioSuperAdmin" type="radio" name="userDiv" :value="0"
                    :disabled="isReadonly('userDiv')" v-model="entity.userDiv" @change="onChange" />
                  <label>BL管理</label>
                </div>
                <div class="radio">
                  <input id="radioAdmin" type="radio" name="userDiv" :value="1"
                    :disabled="isReadonly('userDiv')" v-model="entity.userDiv" @change="onChange" />
                  <label>管理ユーザ</label>
                </div>
                <div class="radio" v-if="this.$session.get('userDiv') !== 0 || this.editMode === 'update'">
                  <input id="radioUser" type="radio" name="userDiv" :value="2"
                    :disabled="isReadonly('userDiv')" v-model="entity.userDiv" @change="onChange" />
                  <label>一般ユーザ</label>
                </div>
              </td>
            </tr>
            <tr id="trEnterpriseCode" v-if="displayEnterpriseCode">
              <td class="w250">企業コード<span class="hissu" v-if="isRequired('enterpriseCode')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }"
                  :rules="`${ isRequired('enterpriseCode') ? 'required' : ''}|numeric|digits:16`" ref="enterpriseCodeIsCheck">
                    <input id="enterpriseCode" type="text" :name="itemName.enterpriseCode" class="form-control enterp-codeInput" autocomplete="off"
                      v-model="entity.enterpriseCode" :readonly="isReadonly('enterpriseCode')" @change="changeEnterpriseCode" @keyup.enter="changeEnterpriseCode" />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr id="trEnterpriseName" v-if="displayEnterpriseName">
              <td class="w250">企業名</td>
              <td>
                <!-- Ajaxで企業名を取得 -->
                <ValidationProvider rules="max:40">
                  <input id="enterpriseName" type="text" :name="itemName.enterpriseName" class="form-control enterp-codeInput"
                    v-model="entity.enterpriseName" :readonly="isReadonly('enterpriseName')" autocomplete="off" />
                  <span class="errMsg errInline" v-if="isErrorEnterpriseName">企業コードが存在しません。</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr id="trSectionCode" v-if="displaySectionCode">
              <td class="w250">拠点コード<span class="hissu" v-if="isRequired('sectionCode')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }"
                  :rules="`${ isRequired('sectionCode') ? 'required' : ''}|alpha_num|max:16`" ref="sectionCodeIsCheck">
                <input id="sectionCode" type="text" :name="itemName.sectionCode" class="form-control enterp-codeInput" autocomplete="off"
                  v-model="entity.sectionCode" :readonly="isReadonly('sectionCode')" @change="changeSectionCode" @keyup.enter="changeSectionCode" />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr id="trSectionName" v-if="displaySectionName">
              <td class="w250">拠点名称</td>
              <td>
                <ValidationProvider rules="max:50">
                  <input id="sectionName" type="text" :name="itemName.sectionName" class="form-control enterp-codeInput"
                    v-model="entity.sectionName" :readonly="isReadonly('sectionName')" autocomplete="off" />
                  <span class="errMsg errInline" v-if="isErrorSectionName">拠点コードが存在しません。</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td class="w250">ユーザ名称<span class="hissu" v-if="isRequired('userName')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }"
                  :rules="`${ isRequired('userName') ? 'required' : ''}|max:50`">
                  <input type="text" :name="itemName.userName" class="form-control enterp-codeInput"
                    v-model="entity.userName" :readonly="isReadonly('userName')" autocomplete="off"  />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td class="w250">ユーザID<span class="hissu" v-if="isRequired('userId')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }"
                  :rules="`${ isRequired('userId') ? 'required' : ''}|alpha_num|min:8|max:16`">
                  <input type="text" :name="itemName.userId" class="form-control enterp-codeInput"
                    v-model="entity.userId" :readonly="isReadonly('userId')" autocomplete="off" />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td class="w250">パスワード<span class="hissu" v-if="isRequired('userPassword')">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }"
                  :rules="`${ isRequired('userPassword') ? 'required' : ''}|alpha_num|min:8|max:12`">
                  <input type="password" :name="itemName.userPassword" class="form-control enterp-codeInput"
                    v-model="entity.userPassword" :readonly="isReadonly('userPassword')" autocomplete="off" />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>

            <tr v-if="isDisplay('inventoryCompletionDiv')">
              <td>棚卸結果DL可否<span class="hissu" v-if="isRequired('inventoryDownloadDiv')">*</span></td>
              <td>
                <div class="radio">
                  <input type="radio" name="inventoryDownloadDiv" :value="0" v-model="entity.inventoryDownloadDiv"
                    :disabled="isReadonly('inventoryDownloadDiv')" />
                  <label>可</label>
                </div>
                <div class="radio">
                  <input type="radio" name="inventoryDownloadDiv" :value="1" v-model="entity.inventoryDownloadDiv"
                    :disabled="isReadonly('inventoryDownloadDiv')" />
                  <label> 不可</label>
                </div>
              </td>
            </tr>
            <!--<tr class="= pagePermission.inventoryCompletionDiv[sessionData.userRank]">
          <td>棚卸対象ファイル操作許可区分<span class="hissu" v-if="isRequired('simpleUserCode')"> if(hissu.stockFileOperationDiv[sessionData.userRank]==""){* }</span></td>
          <td>
        <div class="radio">
        <label><input type="radio" name="stockFileOperationDiv" value="0" = pagePermission.stockFileOperationDiv[sessionData.userRank]  if(pagePermission.stockFileOperationDiv[sessionData.userRank] === "readonly"){ disabled  } /> 可</label>
        </div>
        <div class="radio">
        <label><input type="radio" name="stockFileOperationDiv" value="1" = pagePermission.stockFileOperationDiv[sessionData.userRank]  if(pagePermission.stockFileOperationDiv[sessionData.userRank] === "readonly"){ disabled  } />不可</label>
        </div>
          </td>
        </tr>-->
            <tr v-if="isDisplay('inventoryCompletionDiv')">
              <td>棚卸完了許可区分<span class="hissu" v-if="isRequired('inventoryCompletionDiv')">*</span>
              </td>
              <td>
                <div class="radio">
                  <input type="radio" name="inventoryCompletionDiv" :value="0" v-model="entity.inventoryCompletionDiv"
                    :disabled="isReadonly('inventoryCompletionDiv')" />
                  <label> 可</label>
                </div>
                <div class="radio">
                  <input type="radio" name="inventoryCompletionDiv" :value="1" v-model="entity.inventoryCompletionDiv"
                    :disabled="isReadonly('inventoryCompletionDiv')" />
                  <label>不可</label>
                </div>
              </td>
            </tr>
            <tr v-if="isDisplay('readerSettingDiv')">
              <td>リーダー設定可否区分<span class="hissu" v-if="isRequired('readerSettingDiv')">*</span></td>
              <td>
                <div class="radio">
                  <input type="radio" name="readerSettingDiv" :value="0" v-model="entity.readerSettingDiv"
                    :disabled="isReadonly('readerSettingDiv')" />
                  <label>可</label>
                </div>
                <div class="radio">
                  <input type="radio" name="readerSettingDiv" :value="1" v-model="entity.readerSettingDiv"
                    :disabled="isReadonly('readerSettingDiv')" />
                  <label>不可</label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- ・簡易認証は、企業の簡易認証許可区分を参照 -->
        <div v-if="this.$session.get('simpleAuthenticationDiv') === 0 && isDisplay('simpleUserCode')">
          簡易認証
          <table class="userEdit mt20 mb50">
            <tbody>
              <tr>
                <td class="w250">簡易ID<span class="hissu" v-if="isRequired('simpleUserCode')">*</span></td>
                <td>
                <ValidationProvider v-slot="{ errors }"
                  :rules="`${ isRequired('simpleUserCode') ? 'required' : ''}|alpha_num|min:4|max:7`">
                    <input type="text" :name="itemName.simpleUserCode" class="form-control dataInput"
                    v-model="entity.simpleId" :readonly="isReadonly('simpleUserCode')" autocomplete="off" />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
                </td>
              </tr>
              <tr>
                <td>簡易パスワード<span class="hissu" v-if="isRequired('simplePassword')">*</span></td>
                <td>
                  <ValidationProvider v-slot="{ errors }"
                    :rules="`${ isRequired('simplePassword') ? 'required' : ''}|alpha_num|min:4|max:7`">
                    <input type="password" :name="itemName.simplePassword" class="form-control dataInput"
                      v-model="entity.simplePassword" :readonly="isReadonly('simplePassword')" autocomplete="off" />
                  <span class="errMsg errInline" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ValidationObserver>
      <div class="mb20">
        <button id="saveBtn" class="btn btn-lg btn-primary w200 mr20" type="submit"
          v-if="canEdit() && isDisplay('save')" @click="save">
          保存
        </button>
        <button id="cancelBtn" class="btn btn-lg btn-primary w200" type="button"
          v-if="isDisplay('cancel')" @click="cancel">
          キャンセル
        </button>
      </div>
      <button class="btn btn-lg btn-primary w200"
        type="submit" v-if="showDeleteBtn && isDisplay('delete')" @click="deleteUser">削除</button>
    </div><!-- .container mb50 -->
  </div><!-- .container -->
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'user-edit',

  components: {
    ValidationProvider,
    ValidationObserver
  },

  props: {
    mode: {
      type: String,
      default: null
    },
    enterpriseCode: {
      type: String,
      default: null
    },
    sectionCode: {
      type: String,
      default: null
    },
    userId: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      screenTitle: '[マスタ設定] ユーザ情報設定',
      permissionData: {},
      entity: {
        createDateTime: null,
        enterpriseCode: null,
        enterpriseName: null,
        sectionCode: null,
        sectionName: null,
        userId: null,
        userName: null,
        userPassword: null,
        userDiv: 0,
        simpleId: null,
        simplePassword: null,
        inventoryDownloadDiv: 0,
        stockFileOperationDiv: 0,
        inventoryCompletionDiv: 0,
        readerSettingDiv: 0
      },
      displayEnterpriseCode: false,
      displayEnterpriseName: false,
      displaySectionCode: false,
      displaySectionName: false,
      default: {
        sectionCode: null,
        sectionName: null
      },
      isErrorSectionName: false,
      isErrorEnterpriseName: false,
      itemName: {},
      message: null,
      editMode: this.mode ? this.mode : this.userId ? 'update' : 'entry'
    }
  },

  mounted () {
    this.$emit('setScreenTitle', this.screenTitle)
  },

  /**
   * 初期表示
   */
  async created () {
    this.$emit('setMessage', null, false)
    this.permissionData = this.permission().userEdit[this.editMode]
    this.itemName = this.item()
    if (this.editMode === 'update') {
      var params = {
        enterpriseCode: this.enterpriseCode,
        sectionCode: this.sectionCode,
        userId: this.userId
      }

      var response = await this.axios.get('/api/user/get', {
        params: params,
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      })
      // 取得データを変数に設定
      this.entity = response.data[0]
      this.entity.licenseStartDate = this.$moment(this.entity.licenseStartDate).format('YYYY-MM-DD')
      if (this.entity.licenseEndDate) {
        this.entity.licenseEndDate = this.$moment(this.entity.licenseEndDate).format('YYYY-MM-DD')
      }
      this.default.sectionCode = this.entity.sectionCode
      this.default.sectionName = this.entity.sectionName
    }

    // 表示制限
    if (this.$session.get('userDiv') === 0) {
      // ログイン権限がBL管理者

      if (this.editMode === 'entry') {
        this.displayEnterpriseCode = false
        this.displayEnterpriseName = false
        this.displaySectionCode = false
        this.displaySectionName = false
      } else if (this.editMode === 'update') {
        if (this.entity.userDiv === 0) {
          this.displayEnterpriseCode = false
          this.displayEnterpriseName = false
          this.displaySectionCode = false
          this.displaySectionName = false
        } else {
          this.displayEnterpriseCode = true
          this.displayEnterpriseName = true
          this.displaySectionCode = false
          this.displaySectionName = false
        }
      }
    } else if (this.$session.get('userDiv') === 1) {
      // ログイン権限が管理者

      this.displayEnterpriseCode = true
      this.displayEnterpriseName = true

      if (this.entity.userDiv === 1) {
        this.displaySectionCode = false
        this.displaySectionName = false
      } else if (this.entity.userDiv === 2) {
        this.displaySectionCode = true
        this.displaySectionName = true
      }

      // 新規登録で拠点を本社にする
      if (this.editMode === 'entry') {
        // 初期値は本社IDを設定
        this.entity.userDiv = 1
        this.entity.enterpriseCode = this.$session.get('enterpriseCode')
        this.entity.enterpriseName = this.$session.get('enterpriseName')
        this.entity.sectionCode = this.item().honshaCode
        this.entity.sectionName = this.item().honshaName
      }
    } else {
      // ログイン権限が一般ユーザ

      this.displayEnterpriseCode = true
      this.displayEnterpriseName = true
      this.displaySectionCode = true
      this.displaySectionName = true
    }

    this.displayEnterpriseCode = this.isDisplay('enterpriseCode') ? this.displayEnterpriseCode : false
    this.displayEnterpriseName = this.isDisplay('enterpriseName') ? this.displayEnterpriseName : false
    this.displaySectionCode = this.isDisplay('sectionCode') ? this.displaySectionCode : false
    this.displaySectionName = this.isDisplay('sectionName') ? this.displaySectionName : false
  },

  computed: {
    /**
     * 削除ボタン表示制御
     */
    showDeleteBtn () {
      if (this.editMode === 'update') {
        if (this.$session.get('userDiv') !== 2) {
          if (this.$session.get('userDiv') === 1 && this.$session.get('userId') !== this.entity.userId) {
            return true
          }
          if (this.$session.get('userDiv') === 0) {
            if (this.$session.get('enterpriseCode') !== this.entity.enterpriseCode && this.entity.userDiv === 1) {
              return true
            }
            if (this.$session.get('enterpriseCode') === this.entity.enterpriseCode && this.$session.get('userId') !== this.entity.userId) {
              return true
            }
          }
        }
      }
      return false
    }
  },

  methods: {
    isReadonly (item) {
      if (item === 'userName' || item === 'userPassword') {
        if (this.editMode === 'update' && (this.$session.get('userDiv') === 1 ||
          (this.$session.get('userId') === this.entity.userId &&
          this.$session.get('enterpriseCode') === this.entity.enterpriseCode))) {
          return false
        } else if (this.editMode === 'entry') {
          return false
        } else {
          return true
        }
      }
      return this.permissionData[item][this.$session.get('userDiv')] === 'readonly'
    },
    isDisplay (item) {
      return this.permissionData[item][this.$session.get('userDiv')] !== 'displayNone'
    },
    isRequired (item) {
      return this.permissionData[item][this.$session.get('userDiv')] === ''
    },
    isChecked (item) {
      return this.editMode === 'entry' && this.$session.get('userDiv') === item
    },
    canEdit () {
      return this.editMode === 'entry' || (this.editMode === 'update' &&
        (this.$session.get('userDiv') === 1 ||
        (this.$session.get('userDiv') !== 1 &&
        this.$session.get('userId') === this.entity.userId &&
        this.$session.get('enterpriseCode') === this.entity.enterpriseCode)))
    },

    /**
     * ユーザ権限ラジオボタン選択イベント
     */
    onChange () {
      if (this.$session.get('userDiv') === 0) {
        if (this.editMode === 'entry') {
          // ログイン権限により、ラジオボタンをクリックした場合の処理をする
          if (this.entity.userDiv === 0) {
            this.displayEnterpriseCode = false
            this.displayEnterpriseName = false
          } else if (this.entity.userDiv === 1) {
            this.displayEnterpriseCode = true
            this.displayEnterpriseName = true
          }
        }
      } else if (this.$session.get('userDiv') === 1) {
        if (this.entity.userDiv === 1) {
          this.displaySectionCode = false
          this.displaySectionName = false
          this.entity.sectionCode = this.item().honshaCode
          this.entity.sectionName = this.item().honshaName
        } else if (this.entity.userDiv === 2) {
          this.displaySectionCode = true
          this.displaySectionName = true
          this.entity.sectionCode = this.default.sectionCode
          this.entity.sectionName = this.default.sectionName
        }
      }
    },

    /**
     * 企業コードの変更イベント
     */
    async changeEnterpriseCode () {
      this.$emit('setMessage', null, false)
      var enterpriseCodeIsCheck = await this.$refs.enterpriseCodeIsCheck.validate()
      if (!enterpriseCodeIsCheck.valid || !this.entity.enterpriseCode) {
        this.entity.enterpriseName = ''
        this.isErrorEnterpriseName = false
        return
      }
      var params = {
        enterpriseCode: this.entity.enterpriseCode,
        enterpriseCreateDateFrom: '',
        enterpriseCreateDateTo: ''
      }
      // 企業情報操作（取得）API
      await this.axios.get('/api/enterprise/get', {
        params: params,
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        if (response.data.length === 0) {
          this.entity.enterpriseName = ''
          this.isErrorEnterpriseName = true
        } else {
          this.entity.enterpriseName = response.data[0].enterpriseName
          this.isErrorEnterpriseName = false
        }
      })
    },

    /**
     * 拠点コードの変更イベント
     */
    async changeSectionCode () {
      this.$emit('setMessage', null, false)
      var sectionCodeIsCheck = await this.$refs.sectionCodeIsCheck.validate()
      if (!sectionCodeIsCheck.valid || !this.entity.sectionCode) {
        this.entity.sectionName = ''
        this.isErrorSectionName = false
        return
      }
      var params = {
        enterpriseCode: this.entity.enterpriseCode,
        sectionCode: this.entity.sectionCode
      }
      // 拠点情報操作（取得）API
      await this.axios.get('/api/section/get', {
        params: params,
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        if (response.data[0]) {
          this.entity.sectionName = response.data[0].sectionName
          this.isErrorSectionName = false
        } else {
          this.entity.sectionName = ''
          this.isErrorSectionName = true
        }
      })
    },

    /**
     * 保存ボタン押下
     */
    async save () {
      this.$emit('setMessage', null, false)
      // 入力チェック
      const isValid = await this.$refs.observer.validate()
      if (!isValid || this.isErrorSectionName || this.isErrorEnterpriseName) {
        return
      }

      if (this.editMode === 'entry' && this.$session.get('userDiv') === 0) {
        this.entity.sectionCode = this.item().honshaCode
        this.entity.sectionName = this.item().honshaName
        if (this.entity.userDiv === 0) {
          this.entity.enterpriseCode = this.item().broadleafCode
          this.entity.enterpriseName = this.item().broadleafName
        }
      }

      // 保存処理：ユーザ情報操作（登録・更新）API
      await this.axios.post('/api/user/' + this.editMode, this.entity, {
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        // 保存完了
        this.$emit('setMessage', '保存処理が完了しました。', false)
      })
    },

    /**
     * キャンセルボタン押下
     */
    cancel () {
      // キャンセル処理：企業情報一覧画面に遷移
      this.$router.push({ name: 'user-list' })
    },

    /**
     * 削除ボタン押下
     */
    async deleteUser () {
      if (confirm('削除してもよろしいですか？')) {
        // 削除処理：ユーザ情報操作（削除）API
        await this.axios.post('/api/user/delete', {
          'enterpriseCode': this.enterpriseCode,
          'userId': this.userId
        }, {
          headers: {
            'Authorization': this.$session.get('accessToken'),
            'Content-Type': 'application/json;charset=UTF-8',
            'Access-Control-Allow-Origin': '*'
          }
        }).then((response) => {
          this.$router.push({ name: 'user-list', params: { message: '削除が完了しました。' } })
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/UserEdit.vue